module.exports = __webpack_public_path__ + "static/img/avi_128.2632270d.png";